export enum AppNotificationType {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
  Debug = 'Debug',
}
